import { LabelProps, Label } from './Label';
import classNames from 'classnames';
export function CursiveHeadlineLabel(props: LabelProps) {
    return (
        <Label
            {...props}
            variant="text-headline-cursive"
            color="text-falck-red"
            className={classNames(
                'uppercase italic tracking-wide',
                props.className,
            )}
        />
    );
}
